<mat-form-field>

  <mat-label [innerHtml]="fieldLabel"></mat-label>

  <textarea matInput [formControl]="fieldCtrl"
            spellcheck="true" [lang]="currentLocale"
            cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="15"></textarea>

</mat-form-field>
